import axios from 'axios';
import Vue from 'vue';

const state = {
    user_id: null,
    user_created_date: null,
    user_updated_date: null,
    user_email: null,
    user_first_name: null,
    user_last_name: null,
    user_display_name: null,
    user_picture_url: null
};

const mutations = {
    logout(state){
        state.user_id = null;
        state.created_date = null;
        state.email = null;
        state.email_verified = false;
        state.first_name = null;
        state.last_name = null;
        state.phone = null;
        state.phone_verified = false;
        state.picture_url = null;
        state.two_factor_enabled = false;
        state.updated_date = null;
    },
    data(state, data){
        Object.assign(state, data);
    }
};

const actions = {
    logout({commit, dispatch}){
        return axios.post('/logout')
        .then(() => commit('logout'))
        .then(() => dispatch('products/clear', null, {root: true}));
    },
    load({commit, dispatch}){
        return axios.get('/me')
        .then(response => commit('data', response.$data))
        .then(() => dispatch('products/load', null, {root: true}))
        .then(() => dispatch('courses/load', null, {root: true}))
        .catch(error => {
            if(error?.response?.status === 401){
                //This is an invalid token and we should log the user out
                dispatch('logout');
            }
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
